import styled from 'styled-components';

import { spaceM, space4XL } from '@xing-com/tokens';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spaceM};
  margin-bottom: ${space4XL};
`;

export const ErrorMessage = styled.p`
  margin: 0;
`;
